import { useMutation } from "@tanstack/react-query";
import { axios } from "./axios";
import { useAuth } from "../context/AuthContext";
import { env } from "../utils/env";

interface Params {
  id: number;
}

/** DELETE `/user/access_role/{id}/`. Not yet wired into the Roles & Permissions UI — built alongside the other Role hooks for when a delete/soft-delete action is added. */
export const useDeleteAccessRole = () => {
  const { authHeader } = useAuth();

  return useMutation((params: Params) => {
    return axios.delete(`${env.verifyServiceUrl}user/access_role/${params.id}/`, {
      headers: {
        Authorization: authHeader,
      },
    });
  });
};
